import component from './DevFeatureLocalOverrides';

export default component;
